export function fetchLeadData(lead_id, condition, options) {

	if (options?.signal?.aborted) {
		return Promise.reject(options?.signal?.reason);
	}
	let $ajax = $.ajax({
		type: 'POST',
		dataType: 'json',
		url: '/leads/lead-data',
		data: {'lead_id': lead_id, 'condition': condition},
		cache: false,
	});
	let {promise, reject, resolve} = Promise.withResolvers();

	options?.signal?.addEventListener?.('abort', () => {
		$ajax.abort();
		reject();
	});

	promise.finally(() => {
		options?.signal?.removeEventListener?.('abort', reject);
	});

	resolve($ajax);

	return promise;
}
